export default __webpack_public_path__ + "static/media/thor.cc0c8e8d.png";